export const PAYPAL = 'PayPal'
export const VENMO = 'Venmo'
export const CASHAPP = 'CashApp'
export const CREDIT_CARD = 'Credit Card'
export const SQUARE = 'Square'
export const APPLE_PAY = 'Apple Pay'
export const CASH = 'Cash'
export const ZELLE = 'Zelle'

export const ShopPaymentOptions = {
  [PAYPAL]: 'paypal_email',
  [VENMO]: 'venmo_name',
  [CASHAPP]: 'cashapp',
  [CREDIT_CARD]: 'credit_card',
  [SQUARE]: 'square',
  [APPLE_PAY]: 'applepay_phone',
  [CASH]: 'cash_instrux',
  [ZELLE]: 'zelle_contact',
}

export default {
  VENMO,
  CASHAPP,
  APPLE_PAY,
  PAYPAL,
  CASH,
  CREDIT_CARD,
  SQUARE,
  ZELLE,
}
